import {
  createOrderDetailUrl,
  ORDERS_OVERVIEW_ROUTE,
} from '@aboutyou/legacy-shared/src/pages/AccountArea/routes'
import useProductReviews from '@aboutyou/legacy-shared/src/pages/ProductReview/hooks/useProductReviews'
import { useRouter } from 'helpers/navigation'
import React from 'react'
import styled from 'styled-components'
import Icon, { IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import { complementaryColor } from 'uiComponents/constants/colors'

const StyledLink = styled.button`
  position: absolute;
  background: ${complementaryColor};
  left: 59px;
  top: 48px;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 22px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08), 0 2px 2px 0 rgba(0, 0, 0, 0.05);
`

const BackButton: React.FC<{ productId: number }> = ({ productId }) => {
  const { orderId } = useProductReviews(productId)
  const { navigateClient } = useRouter()
  const handleBackClick = () => {
    const backUrl = orderId
      ? createOrderDetailUrl(orderId)
      : ORDERS_OVERVIEW_ROUTE
    navigateClient(backUrl)()
  }

  return (
    <StyledLink onClick={handleBackClick}>
      <Icon asset={IconName.IcChevronLeft} size={IconSize.XS} />
    </StyledLink>
  )
}

export default BackButton
